import type { RJActivityLogResponse } from 'clients/CampaignsClient/CampaignsClient.types';
import { RJActivityLogStatus, RJCommunicationHubAction } from 'clients/CampaignsClient/CampaignsClient.types';

import { useQuery } from '@tanstack/react-query';
import { campaignsClient } from 'clients/CampaignsClient/CampaignsClient';
import { QueryKey } from 'types/query';

export { RJActivityLogStatus };

export type UseRJActivityLogsQueryParams = {
  es_person_id?: string;
  campaign_id?: number | string;
};

export const rjActivityLogsKey = ({ es_person_id, campaign_id }: UseRJActivityLogsQueryParams) =>
  [QueryKey.useRJActivityLogsQuery, { es_person_id, campaign_id }] as const;

export const useRJActivityLogsQuery = (
  { es_person_id, campaign_id }: UseRJActivityLogsQueryParams,
  options: { enabled?: boolean } = { enabled: true },
) => {
  return useQuery<RJActivityLogResponse>(
    rjActivityLogsKey({ es_person_id, campaign_id }),
    async () => {
      if (!es_person_id || !campaign_id) {
        throw Error('es_person_id and campaign_id are required');
      }

      const { data } = await campaignsClient.getRJActivityLogs({
        es_person_id,
        campaign_id,
      });

      return data;
    },
    {
      enabled: !!es_person_id && !!campaign_id && options.enabled,
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 0,
    },
  );
};

export const handlePauseRJCommunicationHub = (
  { campaign_id, es_person_id }: UseRJActivityLogsQueryParams,
  onSuccess?: () => void,
) => {
  if (!campaign_id || !es_person_id) {
    return;
  }
  campaignsClient
    .manageRJCommunicationHubPipeline({
      campaign_id: Number(campaign_id),
      es_person_id,
      action: RJCommunicationHubAction.Pause,
    })
    .then(() => {
      onSuccess?.();
    });
};
